<template>
  <div class="article-detail">
    <div class="ty-banner-1"><img alt="河南万杰智能科技股份" src="@img/subpage-banner.jpg" title="河南万杰智能科技股份" /></div>
    <search-bar></search-bar>
    <div class="blk-main content clearafter">
      <div class="blk plc">
        <div class="p12-curmbs-1" navcrumbs="">
          <b>您的位置:</b>
          <router-link to="/">主页</router-link>
          &gt;
          <router-link to="/about" v-if="from > 0">关于我们</router-link>
          <router-link to="/news/all" v-else>新闻动态</router-link>
          &gt;
          <router-link :to="'/about/' + classid" v-if="from > 0">{{ classid | toRouterName(this.$router) }}</router-link>
          <router-link :to="'/news/' + classid" v-else>{{ classid | toName(newsClass) }}</router-link>
          &gt;{{ newDetail.title }}
        </div>
      </div>
      <div class="clear"></div>
      <div class="blk-md">
        <div class="tl-fdh-02 blk">
          <ul>
            <li v-for="(data, index) in routes" :key="index">
              <router-link active-class="sidenavcur" :to="'/about/' + data.path">
                <span>{{ data.name }}</span>
              </router-link>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
        <!-- content -->
        <div class="blk-md">
          <div class="p14-infocontent-1 blk">
            <h1 class="p14-infocontent-1-tit">{{ newDetail.title }}</h1>
            <div class="p14-infocontent-1-sour">
              <span>发布日期：{{ newDetail.created_time }}</span>
            </div>
            <div class="p14-infocontent-1-text">
              <div class="p14-infocontent-1-text-t1">信息摘要：</div>
              <div class="p14-infocontent-1-text-t2">{{ newDetail.introduce }}</div>
              <div class="clear"></div>
            </div>
            <div class="p14-infocontent-1-desc endit-content" v-html="newDetail.content"></div>
            <div class="clear"></div>
          </div>
          <div class="p14-info-3 blk">
            <div class="p14-info-3-tit">【相关推荐】</div>
            <div class="p14-info-3-list">
              <ul>
                <li v-for="(item, index) in news" :key="index">
                  <router-link :to="item.classifyid | findpy(item.classify_name, item.id)">{{ item.title }}</router-link>
                  <span><router-link :to="item.classifyid | findpy(item.classify_name, item.id)">了解详情 ></router-link></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="p14-pagination-1 blk">
            <dl>
              <dd>
                上一篇：
                <router-link v-if="up_down.up" :to="up_down.up.classifyid | findpy(up_down.up.classify_name, up_down.up.id)">{{ up_down.up.title }}</router-link>
                <router-link to="" v-else>没有文章了~</router-link>
              </dd>
              <dt></dt>
              <dd>
                下一篇：
                <router-link v-if="up_down.down" :to="up_down.down.classifyid | findpy(up_down.down.classify_name, up_down.down.id)">{{ up_down.down.title }}</router-link>
                <router-link to="" v-else>没有文章了~</router-link>
              </dd>
            </dl>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import searchBar from '../common/searchBar.vue';
import utils from '@/api/to_py.js';
import Player from 'xgplayer';
export default {
  data() {
    return {
      newDetail: {},
      news: [],
      up_down: [],
      from: this.$route.params.from,
      classid: this.$route.params.classid,
      newsClass: []
    };
  },
  metaInfo() {
    return {
      title: this.newDetail.seo_title || this.newDetail.title,
      meta: [
        {
          name: 'keywords',
          content: this.newDetail.seo_keyword || this.newDetail.title
        },
        {
          name: 'description',
          content: this.newDetail.seo_info || this.newDetail.title
        }
      ]
    };
  },
  mounted() {
    // console.log(this.$route.params);
    // 查询文章详情
    this.getArticleDetail();

    // 查询当前分类
    this.searchType();
    // 查询推荐文章
    this.getHotArticle();

    // 查询上一篇下一篇
    this.getUpDown();
  },
  methods: {
    searchType() {
      this.$post('/Article/classify_list', {}).then(response => {
        this.newsClass = response.data;
      });
    },
    getArticleDetail() {
      this.$post('/Article/article_detail', {
        id: this.$route.params.id
      }).then(response => {
        this.newDetail = response.data || {};
      });
    },
    getHotArticle() {
      this.$post('/Article/article_list', {
        is_recommend: 1,
        limit: 5
      }).then(response => {
        this.news = response.data || {};
      });
    },
    getUpDown() {
      this.$post('/Article/article_up_down', {
        id: this.$route.params.id
      }).then(response => {
        this.up_down = response.data || {};
      });
    }
  },
  watch: {
    $route: function(to, from) {
      // console.log(to, from);
      this.getArticleDetail();
    }
  },
  computed: {
    routes() {
      var routes = [];
      var route = this.$router.options.routes;
      for (var i = 0; i < route.length; i++) {
        if (route[i].name == 'about') {
          routes = route[i].children;
        }
      }
      // console.log(routes)
      return routes;
    }
  },
  filters: {
    findpy(id, classifyname, idd) {
      return '/newsdetail/' + utils.ConvertPinyin(classifyname) + '/0' + idd + '.html';
    },
    toName(parm, classes) {
      var curClassName = '';
      try {
        classes.forEach(element => {
          // console.log(element.name);
          if (parm == utils.ConvertPinyin(element.name)) {
            curClassName = element.name;
            // console.log(curClassName,element.name)
            throw Error();
          }
        });
      } catch (e) {}
      return curClassName;
    },
    toRouterPath(name, router) {
      // console.log(name, router);
      // var curClassPath = '';
      // try {
      //   router.options.routes.forEach(element => {
      //     // console.log(element.name);
      //     if (name == element.name) {
      //       throw Error();
      //     }
      //   });
      // } catch (e) {}
      // return curClassPath;
    },
    toRouterName(name, router) {
      var curClassName = '';
      try {
        router.options.routes.forEach(element => {
          // console.log(element.name);
          if (element.name == 'about') {
            element.children.forEach(ele => {
              if (name == ele.path) {
                curClassName = ele.name;
                // console.log(ele.name);
                throw Error();
              }
            });
          }
        });
      } catch (e) {}
      return curClassName;
    }
  },
  components: {
    searchBar
  }
};
</script>

<style lang="less">
@import '~@css/warp.less';
.endit-content {
  img {
    display: inline-block;
  }
  video {
    width: 60%;
    margin: 0 auto 15px;
  }
  * {
    max-width: 100% !important;
  }
}
#video {
  width: 80%;
  margin: 0 auto;
}
.article-detail {
  background: rgba(247, 247, 247, 1);
  padding-bottom: 80px;
  .tl-fdh-02 {
    height: 55px;
    background: #fff;
    margin-bottom: 20px;
    overflow: hidden;
    li {
      width: 14.28%;
      height: 55px;
      font-size: 18px;
      line-height: 55px;
      text-align: center;
      float: left;
      box-sizing: border-box;
      background: #fff;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:last-child {
        a {
          border-right: 0;
        }
      }
      a {
        color: rgba(102, 102, 102, 1);
        border-right: 1px solid rgba(238, 238, 238, 1);
        display: block;
        &:hover,
        &.sidenavcur {
          // background: url(~@img/p16-icon6.png) no-repeat bottom center rgba(19, 181, 179, 1);
          background-color: rgba(19, 181, 179, 1);
          border-color: rgba(19, 181, 179, 1);
          span {
            color: #fff;
          }
        }
      }
    }
  }
  .p14-infocontent-1 {
    background: #fff;
    padding: 18px 44px;
    .p14-infocontent-1-tit {
      height: 38px;
      font-size: 24px;
      font-weight: normal;
      line-height: 38px;
      color: #4b4a4a;
      text-align: center;
    }
    .p14-infocontent-1-sour {
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      color: #aaa;
      margin-bottom: 20px;
      a {
        color: #aaa;
      }
      span {
        margin: 0 9px;
      }
    }
    .p14-infocontent-1-text {
      padding: 16px 18px;
      font-size: 14px;
      line-height: 24px;
      border: 1px solid #d6d6d6;
      margin-bottom: 22px;
      .p14-infocontent-1-text-t1 {
        width: 78px;
        float: left;
        color: #342f2e;
        margin-right: -78px;
      }
      .p14-infocontent-1-text-t2 {
        padding-left: 80px;
      }
    }
    .endit-content {
      line-height: 28px;
    }
  }
  .p14-info-3 {
    background: #fff;
    padding: 0 20px 8px;
    .p14-info-3-tit {
      height: 55px;
      font-size: 20px;
      line-height: 55px;
      color: #4b4a4a;
    }
    .p14-info-3-list {
      li {
        height: 46px;
        font-size: 14px;
        line-height: 46px;
        color: #4b4a4a;
        border-top: 1px dashed #dbdbdb;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        a {
          color: #4b4a4a;
        }
        span {
          float: right;
        }
      }
    }
  }
  .p14-pagination-1 {
    dl {
      margin-bottom: 24px;
      padding-right: 40px;

      dd {
        height: 32px;
        font-size: 14px;
        line-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        b {
          float: right;
          font-weight: normal;
        }
        span {
          width: 60px;
          height: 32px;
          background: #a2a2a2;
          color: #fff;
          text-align: center;
          display: inline-block;
          margin-right: 10px;
        }
        em {
          float: right;
          font-style: normal;
          padding-left: 20px;
          font-weight: normal;
        }
      }
      dt {
        height: 1px;
        border-bottom: 1px dashed #b5b5b5;
        margin-left: 60px;
        padding-top: 2px;
        margin-bottom: 2px;
      }

      a {
        color: #4b4a4a;
      }
    }
    .p14-pagination-1-href {
      float: right;
      font-size: 18px;
      line-height: 32px;
      // span {
      //   display: inline-block;
      //   padding: 0 6px;
      //   margin-left: 4px;
      //   background: #f97b47;
      // }
      a {
        display: block;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news/detail.vue